<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{ $t("HOTEL_CONFIG") }}</span>
    </page-header>
    <left-menu />
     <v-card id="setting-screen">
        <template>
        <div class="main-content">
            <div class="content">
                <div id="display-giftCode">
                    <div class="tab-header">
                        <v-row>
                            <v-col>
                                <label class="tab-title">{{$t('GIFT_CODE_LIST')}}</label>
                            </v-col>
                            <v-col class="text-right">
                                <b-button variant="primary" class="btnSearch" @click="creat">{{$t('ADD_NEW')}}</b-button>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="tab-content">
                        <b-form v-on:keyup.enter="apiListGiftCode()">
                            <v-row class="search">
                                <v-col md="2">
                                    {{$t('TIME_APPLY')}}
                                    <datepicker placeholder="dd-MM-yyyy" @click.native="checkFromDate" :disabledDates="stateFrom.disabledDates" v-model="form.fromDate" name="uniquename"
                                    :language="$i18n.locale === 'vi'? vi : en"
                                    format="dd-MM-yyyy"></datepicker>
                                        <p v-if="form.fromDate===null && form.toDate !== null" class="text-danger">
                                            {{$t('_VALIDATE.REQUIRED')}}
                                        </p>
                                    <icon	v-if="form.fromDate===null"	class="mt-1 mr-2" name="sort-down" scale="1" style="color:#258fe0;position: absolute;top: 22px;right: 15px;"></icon>
                                    <icon v-if="form.fromDate!==null" @click.native="clearDateFrom()" class="mt-1 mr-2" name="calendar-times" scale="1" style="color:#258fe0;position: absolute;top: 22px;right: 15px;"></icon>
                                </v-col>
                                <v-col md="2" class="pt-4">
                                    <datepicker placeholder="dd-MM-yyyy" @click.native="checkToDate" :disabledDates="stateTo.disabledDates" v-model="form.toDate" name="uniquename"
                                    :language="$i18n.locale === 'vi'? vi : en"
                                    format="dd-MM-yyyy"></datepicker>
                                        <p class="text-danger" v-if="form.fromDate!==null && form.toDate === null">
                                            {{$t('_VALIDATE.REQUIRED')}}
                                        </p>
                                    <icon v-if="form.toDate!==null" @click.native="clearDateTo()" class="mt-1 mr-2" name="calendar-times" scale="1" style="color:#258fe0;position: absolute;top: 22px;right: 15px;" ></icon>
                                    <icon v-if="form.toDate===null" class="mt-1 mr-2" name="sort-down" scale="1" style="color:#258fe0;position: absolute;top: 22px;right: 15px;" ></icon>
                                </v-col>
                                <v-col md="2">
                                    {{$t('GIFT_CODE')}}
                                    <b-form-input class="input-radius" id="code" type="text" name="code" size="md" style="text-transform:uppercase" v-model.trim="form.giftCode" autocomplete="nope"></b-form-input>
                                </v-col>
                                <v-col md="2">
                                    {{$t('CONDITION')}}
                                    <b-form-select  class="input-radius"  id="condition"  type="text"  name="condition" size="md"  v-model.trim="form.condition">
                                        <option :value="null">--{{$t('ALL')}}--</option>
                                        <option :value="0">{{$t('CONDITION_NOT_START')}}</option>
                                        <option :value="1">{{$t('CONDITION_RUNNING')}}</option>
                                        <option :value="2">{{$t('CONDITION_OVER')}}</option>
                                        <option :value="3">{{$t('CONDITION_AVAIL_EMPTY')}}</option>
                                        <option :value="4">{{$t('CONDITION_STOP')}}</option>
                                    </b-form-select>
                                </v-col>
                                <v-col md="2">
                                    {{$t('STATUS_GIFT')}}
                                    <b-form-select  class="input-radius"  id="status"  type="text"  name="status" size="md"  v-model.trim="form.status">
                                        <option :value="null">--{{$t('ALL')}}--</option>
                                        <option :value="true">{{$t('ACTIVE')}}</option>
                                        <option :value="false">{{$t('DEACTIVE')}}</option>
                                    </b-form-select>
                                </v-col>
                                <v-col md="2">
                                    {{$t('GIFT_CODE_TYPE')}}
                                    <b-form-select  class="input-radius"  id="discountType"  type="text"  name="discountType" size="md"  v-model.trim="form.discountType" @change="checkDiscountType()">
                                        <option :value="null">--{{$t('ALL')}}--</option>
                                        <option :value="1">{{$t('DISCOUNT_TYPE_PERCENT')}}</option>
                                        <option :value="2">{{$t('DISCOUNT_TYPE_MONEY')}}</option>
                                    </b-form-select>
                                </v-col>
                                <v-col md="2">
                                    {{$t('DISCOUNT_RATE')}}
                                    <vue-numeric class="input-radius numberInput" :disabled="form.discountType === null " v-bind:max="form.discountType === 1 ? 100 : 99999999999999999999999" :empty-value="0" v-on:keypress="isNumber(event)" separator="," v-model="form.discountAmountFrom" ></vue-numeric>
                                </v-col>
                                <v-col md="2" class="pt-4">
                                    <vue-numeric class="input-radius numberInput" :disabled="form.discountType === null " v-on:keypress="isNumber(event)" v-bind:max="form.discountType === 1 ? 100 : 999999999999999999999" separator="," v-model="form.discountAmountTo" :placeholder="$t('TO_MONEY')"></vue-numeric>
                                    <span class="text-danger" v-if="form.discountAmountTo < form.discountAmountFrom">{{$t('ENTER_AMOUNT_INCORRECT')}}</span>
                                </v-col>
                                <v-col md="2">
                                    {{$t('MINIMUM_ORDER_VALUE')}}
                                    <vue-numeric  class="input-radius numberInput" :empty-value="0" v-on:keypress="isNumber(event)" separator="," v-model="form.minPriceFrom"  ></vue-numeric>
                                </v-col>
                                <v-col md="2" class="pt-4">
                                    <vue-numeric class="input-radius numberInput"  v-on:keypress="isNumber(event)" separator="," v-model="form.minPriceTo" :placeholder="$t('TO_MONEY')" ></vue-numeric>
                                    <span class="text-danger" v-if="form.minPriceTo < form.minPriceFrom">{{$t('ENTER_AMOUNT_INCORRECT')}}</span>
                                </v-col>
                                <v-col class="pt-4">
                                    <b-button variant="warning" :disabled="form.minPriceTo < form.minPriceFrom || form.discountAmountTo < form.discountAmountFrom" class="btnSearch" @click="apiListGiftCode">{{$t('_BOOKING.SEARCH')}}</b-button>
                                </v-col>
                                <v-col md="12" class="pb-3">
                                    <b-form-input type="text" name="name" v-model="form.giftCodeName" placeholder="Tìm kiếm theo tên chương trình"></b-form-input>
                                </v-col>
                            </v-row>
                        </b-form>
                        <v-row class="tbl-gift">
                            <v-col>
                                <v-row class="">
                                    <v-col class="text-right">
                                        <b-table responsive  id="listHotel" show-empty :items="items"  :per-page="20" :current-page="currentPage" :fields="fields"  class="text-left mt-3" :busy="loading" small hover >
                                            <div slot="table-busy" class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                            </div>
                                            <template v-slot:cell(STT)="row">
                                                <v-row>
                                                    <v-col align="left">{{row.index + 1 + (currentPage*20 - 20)}}</v-col>
                                                </v-row>
                                            </template>
                                            <template v-slot:cell(giftCode)="row">
                                                <b>{{row.item.giftCode}}</b><br>
                                                <span class="text-secondary">{{$t('MINIMUM')}} {{formatPrice(row.item.minPrice)}} VND</span>
                                            </template>
                                            <template v-slot:cell(display)="row">
                                                <v-row>
                                                    <v-col v-if="row.item.display===true" class="text-center">
                                                        <i class="icon-active-ic" style="font-size: 24px; color: #07992e; position: relative; top: 3px"></i>
                                                    </v-col>
                                                    <v-col v-else class="text-center">
                                                        <i class="icon-cancel-ic" style="font-size: 24px; color: #e50b16; position: relative; top: 3px"></i>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                            <template v-slot:cell(discountAmount)="row">
                                                {{row.item.discountType === 1 ? row.item.discountAmount : formatPrice(row.item.discountAmount)}} {{row.item.discountType === 1 ? '%' : 'VND'}}
                                            </template>
                                            <template v-slot:cell(availAmount)="row">
                                                {{row.item.availAmount}}/{{row.item.totalAmount}}
                                            </template>
                                            <template v-slot:cell(paymentType)="row">
                                                {{$t(row.item.paymentType)}}
                                            </template>
                                            <template v-slot:cell(startActDate)="row">
                                                <span v-if="row.item.dateType === 1">{{$t('ALWAYS')}}</span>
                                                <span v-if="row.item.dateType !== 1">{{formatDate(row.item.startActDate)}} - {{formatDate(row.item.endActDate )}}</span>
                                            </template>
                                            <template v-slot:cell(status)="row">
                                                <v-row>
                                                    <v-col v-if="row.item.status===true" class="text-center">
                                                        <i class="icon-active-ic" style="font-size: 24px; color: #07992e; position: relative; top: 3px"></i>
                                                        <!-- <md-switch v-model="row.item.active" :disabled ="disable===true"  @change="act(row.item.hotelId,row.item.title, row.value)"></md-switch> -->
                                                    </v-col>
                                                    <v-col v-else class="text-center">
                                                        <i class="icon-cancel-ic" style="font-size: 24px; color: #e50b16; position: relative; top: 3px"></i>
                                                    </v-col>
                                                </v-row>
                                                <!-- <span v-if="row.item.status === true" class="text-success">{{$t('ACTIVE')}}</span>
                                                <span v-else class="text-danger">{{$t('DEACTIVE')}}</span> -->
                                            </template> 
                                            <template v-slot:cell(notApplyDate)="row">
                                                <p style="font-size: 12px" class="m-0" v-for="i in row.item.arrNotApplyDate" :key="i">{{formatDate(i) !== 'Invalid date' ? formatDate(i) : ''}}</p>
                                            </template>
                                            <template v-slot:cell(condition)="data">
                                                <span v-if="data.item.condition === 0" class="text-success">{{$t('CONDITION_NOT_START')}}</span>
                                                <span v-if="data.item.condition === 1" class="text-primary">{{$t('CONDITION_RUNNING')}}</span>
                                                <span v-if="data.item.condition === 2" class="text-warning">{{$t('CONDITION_OVER')}}</span>
                                                <span v-if="data.item.condition === 3" class="text-secondary">{{$t('CONDITION_AVAIL_EMPTY')}}</span>
                                                <span v-if="data.item.condition === 4" class="text-danger">{{$t('CONDITION_STOP')}}</span>
                                            </template>
                                            <template v-slot:cell(act5)="row">
                                                <v-row>
                                                    <v-col md="6" class="text-center">
                                                            <b-button size="sm" @click="edit(row.item)"
                                                                style="background-color: transparent; border: 0;height: 28px; padding:0;">
                                                                <i :title="$t('EDIT')" class="icon-edit-ic" style="font-size: 20px; color: #2776e5; position: relative; top: -1px"></i>
                                                            </b-button>
                                                    </v-col>
                                                    <v-col md="6">
                                                        <b-button size="sm" @click="deleteCode(row.item)"
                                                            style="background-color: transparent; border: 0;height: 28px; padding:0;">
                                                            <i :title="$t('DELETE')" class="icon-delete-ic" style="font-size: 20px; color: red; position: relative; top: -1px"></i>
                                                        </b-button>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </b-table>
                                        <v-row class="pagination-list pt-3">
                                            <v-col class="wrap-pagination-list text-right">
                                                <span class="member-register-total">{{$t('TOTAL')}}: {{totalRows}} {{$t('GIFT_CODE')}}</span>
                                                <b-pagination
                                                    :total-rows="totalRows"
                                                    :per-page="20"
                                                    v-model="currentPage"
                                                    align="right"
                                                ></b-pagination>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </div>
    </template>
     </v-card>
    
  </v-app>
</template>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { giftCodeService } from "@/_services/GiftCodeService.js";
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import Datepicker from 'vuejs-datepicker';
import { en, vi } from 'vuejs-datepicker/dist/locale';
import { CoolSelect } from 'vue-cool-select';
import VueNumeric from 'vue-numeric'
export default {
	data() {
		return {
			en,
			vi,
			stateFrom: {},
			stateTo: {},
			form: {
				fromDate: null,
				toDate: null,
				giftCode: null,
				condition: null,
				status: null,
				paymentType: null,
				discountAmountFrom: null,
				discountAmountTo: null,
				minPriceFrom: null,
				minPriceTo: null,
				discountType: null,
				giftCodeName: null,
			},
			items: [],
			fields: [],
			currentPage: 1,
			loading: true,
			totalRows: 0,
		};
	},
	components: {
        "page-header": PageHeader,
        "left-menu": LeftMenu,
		DatePicker,
		Datepicker,
        Treeselect,
        VueNumeric
	},
	created() {
		const now = new Date();
		this.form.fromDate = new Date();
		this.form.toDate = now;
		this.form.toDate.setDate(now.getDate() + 7);
		if (this.$i18n.locale === 'vi') {
			this.fields = [
				{ key: 'STT', label: 'STT', class: 'stt' },
				{ key: 'giftCode', label: 'Mã giảm giá', class: '' },
				{ key: 'name', label: 'Tên chương trình', class: '' },
				{ key: 'discountAmount', label: 'Mức giảm giá', class: '' },
				{ key: 'availAmount', label: 'Còn lại/Tổng', class: '' },
				{ key: 'paymentType', label: 'Loại chi phí', class: '' },
				{ key: 'startActDate', label: 'Thời gian áp dụng', class: '' },
				{ key: 'notApplyDate', label: 'Không áp dụng', class: '' },
				{ key: 'condition', label: 'Tình trạng', class: '' },
				{ key: 'status', label: 'Trạng thái', class: '' },
				{ key: 'display', label: 'HT trên web', class: '' },
				{ key: 'act5', label: 'Thao tác', class: '' },
			];
		} else {
			this.fields = [
				{ key: 'STT', label: 'STT', class: 'stt' },
				{ key: 'giftCode', label: 'Gift code', class: '' },
				{ key: 'name', label: 'Program name', class: '' },
				{ key: 'discountAmount', label: 'Discount amount', class: '' },
				{ key: 'availAmount', label: 'Remail/Total', class: '' },
				{ key: 'paymentType', label: 'Payment Type', class: '' },
				{ key: 'startActDate', label: 'Time application', class: '' },
				{ key: 'notApplyDate', label: 'Do not apply', class: '' },
				{ key: 'condition', label: 'Condition', class: '' },
				{ key: 'status', label: 'Status', class: '' },
				{ key: 'display', label: 'Display on web', class: '' },
				{ key: 'act5', label: 'Manipulation', class: '' },
			];
		}
		this.apiListGiftCode();
	},
	computed: {},
	methods: {
        formatDate(i) {
            return moment(i).format('DD/MM/YYYY')
        },
		checkDiscountType() {
			this.form.discountAmountFrom = 0;
			this.form.discountAmountTo = null;
		},
		creat() {
            this.$router.push({
                name: "giftCodeCreat"
            });
		},
        edit(item) {
            this.$router.push({
                name: "giftCodeEdit",
                query: {
                    gid: item.giftCode
                } 
            });
        },
		clearDateFrom() {
			this.form.fromDate = null;
		},
		clearDateTo() {
			this.form.toDate = null;
		},
		checkFromDate() {
			const startDate = new Date(moment(this.form.fromDate));
			const toDate = new Date(moment(this.form.toDate));
			if (startDate > toDate) {
				this.form.fromDate = new Date(moment(this.form.toDate));
			}
			this.checkDateToHotel();
		},
		checkToDate() {
			const startdate = new Date(moment(this.form.fromDate));
			this.stateTo = {
				disabledDates: {
					to: new Date(startdate.setDate(startdate.getDate())),
				},
			};
		},
		isNumber(evt) {
			evt = evt || window.event;
			const charCode = evt.which ? evt.which : evt.keyCode;

			if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		apiListGiftCode() {
			this.loading = true;
			const body = {
                fromDate:
                    moment(this.form.fromDate).format('YYYY-MM-DD ') === 'Invalid date'
                        ? null
                        : moment(this.form.fromDate).format('YYYY-MM-DD'),
                toDate:
                    moment(this.form.toDate).format('YYYY-MM-DD ') === 'Invalid date'
                        ? null
                        : moment(this.form.toDate).format('YYYY-MM-DD'),
                giftCode: this.form.giftCode === null ? null : this.form.giftCode.toUpperCase(),
                condition: this.form.condition,
                status: this.form.status,
                paymentType: this.form.paymentType,
                discountType: this.form.discountType,
                discountAmountFrom: this.form.discountAmountFrom,
                discountAmountTo: this.form.discountAmountTo === 0 ? null : this.form.discountAmountTo,
                minPriceFrom: this.form.minPriceFrom,
                minPriceTo: this.form.minPriceTo === 0 ? null : this.form.minPriceTo,
                giftCodeName: this.form.giftCodeName,
            };
				giftCodeService.getList(body).then(
					response => {
						this.loading = false;
						if (response.responseCode === 0) {
							this.items = response.data;
							this.items.forEach(e => {
								e.arrNotApplyDate = e.notApplyDate.split(',');
							});
							this.totalRows = this.items.length;
						}
					},
					error => {
						if (error.status === 403) {
							this.showAlertLogout();
						}
					},
				);
		},
		deleteCode(code) {
			this.$swal({
				title: this.$t('CONFIRM_DELETE_GIFT_CODE'),
				type: 'warning',
				html: this.$t('PROMOTION_NOT_BE_DISPLAY'),
				allowOutsideClick: false,
				showCloseButton: false,
				showCancelButton: true,
				showConfirmButton: true,
				focusConfirm: false,
				confirmButtonText: this.$t('CONFIRM'),
				cancelButtonText: this.$t('CLOSE'),
				cancelButtonColor: 'red',
			}).then(result => {
				if (result.value) {
					giftCodeService.remove(code.id).then(
						response => {
							if (response.responseCode === 0) {
								this.apiListGiftCode();
								this.$bvToast.toast(this.$t(response.data), {
									title: this.$t('DELETE_SUCCESS'),
									variant: 'success',
									solid: true,
									autoHideDelay: 1500,
								});
							} else {
								this.$bvToast.toast(this.$t(response.data), {
									title: this.$t('DELETE_FAILE'),
									variant: 'danger',
									solid: true,
									autoHideDelay: 1500,
								});
							}
						},
						error => {
							if (error.status === 403) {
								this.showAlertLogout();
							}
						},
					);
				}
			});
		},
		formatPrice(value) {
			const val = (value / 1).toFixed(0).replace('.', '.');
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		},
		showAlertLogout() {},
		//
	},
};
</script>
<style lang="scss">
    #display-giftCode{
        [disabled] {
            background: #f5f5f5;
        }
    .btn-primary{
        background: #173d8f;
        color: #ffff;
        border: 0;
    }
    .pt-4{
        padding-top: 33px !important;
    }
    .input-radius{
        height: 41px;
    }
   	.search{
		background-color: #fff;
        border-radius: 5px;
        .numberInput{
            border: 1px solid #ccc;
            width:100%;
            text-align:right;
            padding-right: 5px;
            color: #808080;
        }
        .btnSearch{
            width: 100%;
        }
        .vdp-datepicker input {
            height: 41px;
            width: 100%;
            padding-left: 20px;
            border-radius: 5px;
            border: 1px solid #ccc;
        }
        .md-field.md-clearable .md-input{
            padding-right: 0 !important;
        }
        .md-datepicker-dialog{
            position: absolute;
            left: 87px;
            will-change: top, left;
            top: 170px !important;
        }
        .md-datepicker-body-content {
            height: 300px !important;
        }
	}
    .tbl-gift{
		background-color: #fff;
        border-radius: 5px;
		th{
			white-space: nowrap;
            background: none;
            border: 0;
            padding: 0.75rem;
            font-size: 12px;
		}
        td{
            vertical-align: middle;
            padding: 0.75rem;
        }
        table thead {
            background: #fafafa;
        }
        .page-link{
            border: none;
        }
        tbody tr{
            border-bottom: 1px solid #ccc;
        }
        .pagination-list {
            .active {
                    border-right: 0px  !important;
                }
            float: right;
				.wrap-pagination-list {
					display: flex;
					flex-direction: row;
					span.member-register-total {
						font-size: 14px;
						line-height: 2.22;
						letter-spacing: 1px;
						text-align: right;
						color: #808080;
						margin-right: 20px;
					}
					.page-item .page-link {
						color: #173d8f;
						font-weight: 500;
					}
					.page-item.active .page-link {
						z-index: 1;
						font-size: 14px;
						font-weight: 500;
						color: #808080;
						background: #fff;
					}
				}
			}
    }
    .pad-left-10 {
        padding-left: 10px;
    }
}
</style>